export default function keyJoiner (parentKey, childKey) {
  return parentKey + '[' + childKey + ']'
}
